export default class Service {
  constructor(base) {
    this.base = base;

    return {
      BASE: this.base,
      PREFIX: this.prefix
    };
  }

  get prefix() {
    return this.base.replace(/\/$/, '');
  }
};



// WEBPACK FOOTER //
// ./src/app/shared/constants/service.js